import gql from 'graphql-tag';

export const bulkAssignTaskMemberMutation = gql`
  mutation bulkAssignTaskMember(
    $taskIds: [String!]!
    $assignee: String!
  ) {
    bulkAssignTaskMember(
      taskIds: $taskIds
      assignee: $assignee
    ) {
      successCount
      failureCount
      failures {
        taskId
        reason
      }
    }
  }
`;

